/** Public FAQ. No login. Copy lives with the page; this list drives headings, hashes, and tests. */

export const FAQ_PATH = "/faq";

export const FAQ_CATEGORIES = [
  { id: "start", title: "Getting started" },
  { id: "plans", title: "Plans and limits" },
  { id: "security", title: "Your data" },
  { id: "hawaii", title: "Hawaii forms and calculators" },
];

export const FAQ_ITEMS = [
  {
    id: "what-is-terrakronos",
    category: "start",
    question: "What is TerraKronos?",
  },
  {
    id: "no-google",
    category: "start",
    question: "What if I don't have a Google account?",
  },
  {
    id: "credit-card",
    category: "start",
    question: "Do I need a credit card to start?",
  },
  {
    id: "try-without-account",
    category: "start",
    question: "Can I try it before I sign up?",
  },
  {
    id: "client-link",
    category: "start",
    question: "Can my client see dates without an account?",
  },
  {
    id: "plan-limits",
    category: "plans",
    question: "Do archived or deleted transactions count against plan limits?",
  },
  {
    id: "whats-free",
    category: "plans",
    question: "What do I get on the free plan?",
  },
  {
    id: "cancel",
    category: "plans",
    question: "Can I cancel anytime?",
  },
  {
    id: "security",
    category: "security",
    question: "How secure is my data?",
  },
  {
    id: "who-can-see",
    category: "security",
    question: "Who can see my deals?",
  },
  {
    id: "squaredeal",
    category: "hawaii",
    question: "What is SquareDeal?",
  },
  {
    id: "har-forms",
    category: "hawaii",
    question: "Can I fill HAR purchase contracts in the app?",
  },
  {
    id: "calculator-accuracy",
    category: "hawaii",
    question: "How accurate are your calculators?",
  },
  {
    id: "not-a-crm",
    category: "hawaii",
    question: "Is this a CRM or an MLS tool?",
  },
];

export function faqItemsByCategory(categoryId) {
  return FAQ_ITEMS.filter((item) => item.category === categoryId);
}

export function faqItemById(id) {
  return FAQ_ITEMS.find((item) => item.id === id) || null;
}
